import { Link } from 'react-router-dom';
import { usePortalDestination } from './PortalDestinationContext';
import { PRIMARY_NAV } from './portalNavigation';
import { usePortalUnread } from './PortalUnreadContext';
import { PortalUnreadBadge, unreadChatLabel } from './PortalUnreadBadge';

/** Compact left rail — desktop only (see portalMobile.css). Same five destinations as the mobile tab bar. */
export const PortalSideRail = () => {
  const { href, parsed } = usePortalDestination();
  const { count } = usePortalUnread();
  return (
    <aside className="portal-side-rail" aria-label="Patient services" data-testid="portal-side-rail">
      {PRIMARY_NAV.map(({ page, icon: Icon, label, id, matches }) => {
        const isActive = (matches || [page]).includes(parsed.page);
        return (
          <Link key={id} to={href(page)}
            aria-label={id === 'chat' ? unreadChatLabel(count) : undefined}
            aria-current={isActive ? 'page' : undefined}
            className={`portal-rail-tab${isActive ? ' portal-rail-tab-active' : ''}`}
            data-testid={`portal-rail-${id}`}>
            <span className="portal-rail-icon"><Icon size={20} strokeWidth={isActive ? 2.4 : 1.8} aria-hidden="true" />
              {id === 'chat' && <PortalUnreadBadge count={count} floating testId="portal-rail-chat-unread-count" />}
            </span>
            <span className="portal-rail-label">{label}</span>
          </Link>
        );
      })}
    </aside>
  );
};
